import Moment from 'moment';


//When serializing an object to JSON, Moment and date objects will be represented as an ISO8601 string, adjusted to UTC.
//The overrides below ensures that the utcOffsets are maintained when serialized to JSON

// eslint-disable-next-line 
Date.prototype.toJSON = function(){ return Moment(this).format(); }
Moment.fn.toJSON = function() { return this.format(); }